import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const CouponSuccess = loadable(() => pMinDelay(import('./CouponSuccess'), 300), {
  fallback: <Loading />
});

const AsyncCouponSuccess = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    loadGameListFull: true,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <CouponSuccess { ...props }/>
    </ApplicationLayout>
  );
};

AsyncCouponSuccess.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncCouponSuccess;
